import React from "react";
import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({

  MainHelper:{
    display: "flex",
    boxShadow: 1,
    flexDirection: "column",
    minHeight:"100%"
  },
  button: {
    "&:focus": {
      outline: 0,
    },
  },
  cardStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    minHeight: "300px",
    marginBottom: theme.spacing(2)
  },
  playerStyle: {
    display: "flex",
    justifyContent: "center",
    width: "40%",
    padding: theme.spacing(2),
  },
  textContainer: {
    boxSizing: "border-box",
    width: "55%",
    padding: theme.spacing(2)
  },
  recorderWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

}));
